import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

export type WarningType = "warning" | "error";

/**
 * WarningComponent is a component to display warning messages.
 * It can either display a simple text message or custom content.
 */
@Component({
  selector: "app-warning",
  templateUrl: "./warning.component.html",
  styleUrls: ["./warning.component.scss"],
  imports: [CommonModule],
  standalone: true
})
export class WarningComponent {
  @Input() type: WarningType = "warning";
  /**
   * The text to display in the warning message.
   */
  @Input() text = "";

  /**
   * Indicates whether the warning component has child content.
   * If true, the component will project the custom content inside it.
   */
  @Input() hasChildContent = false;
}
